import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import { CustomersAndOrdersViewAccessControl } from '../access-control/customersAndOrdersAdminAccess.configuration'

const CustomersAndOrdersAdminPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CustomersAndOrdersAdminPage" */
      '../pages/admin/customers-and-orders/CustomersAndOrdersAdminPage'
    )
)

const CustomerDetailPageWithLegacyFallback = lazy(
  () =>
    import(
      /* webpackChunkName: "CustomersAndOrdersAdminPage" */
      '../pages/admin/customers-and-orders/CustomerDetailPageWithLegacyFallback'
    )
)

const OrderDetailPageWithLegacyFallback = lazy(
  () =>
    import(
      /* webpackChunkName: "CustomersAndOrdersOrderDetailPage" */
      '../pages/admin/customers-and-orders/OrderDetailPageWithLegacyFallback'
    )
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const customersAndOrdersAdminRouter = (
  <DomainRoute route="app-admin-customers-and-orders">
    <DashSwitch>
      <DomainRedirect
        fromRoute="app-admin-customers-and-orders-dashboard"
        toRoute="app-admin-customers-and-orders-dashboard-legacy"
        exact
      />
      <DomainRoute
        exact
        route="app-admin-customers-and-orders-ipp-customer-details"
        component={CustomerDetailPageWithLegacyFallback}
      />
      <DomainRoute
        exact
        route="app-admin-customers-and-orders-ipp-customer-order-details"
        component={OrderDetailPageWithLegacyFallback}
      />
      <DomainRoute
        route="app-admin-customers-and-orders-dashboard-wildcard"
        component={CustomersAndOrdersAdminPage}
        accessControl={CustomersAndOrdersViewAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
